export default "__VITE_ASSET__Sviu$zZV__";